import React from "react";

import {withStyles} from "@material-ui/core/styles";

import GridContainer from "../../components/Grid/GridContainer";
import GridItem from "../../components/Grid/GridItem";
import Card from "../../components/Card/Card";
import CardBody from "../../components/Card/CardBody";

import Button from "components/CustomButtons/Button.js";

import Refresh from "@material-ui/icons/Refresh";
import Subject from "@material-ui/icons/Subject";
import styles from "assets/jss/material-kit-pro-react/views/componentsSections/sectionCards.js";
import InvitationRotatingCard from "./InvitationRotatingCard";
import {withSnackbar} from "notistack";
import UserChangeRotatingCard from "./UserChangeRotatingCard";
import {getUserInvitation} from "../../utils/request";
import UserChangeDialog from "../dialog/UserChangeDialog";
import AccountProme from "./AccountProme";
import intl from "react-intl-universal";


class AccountUserInfo extends React.Component {


	constructor(props, context) {
		super(props, context);
		this.state = {
			userInvitationCountEffective: '0',
			openChangeDialog: false,
			promes: [],
			users: [],
		};
		this.initData();
	}

	initData = () => {
		getUserInvitation().then(res => {
			// console.log(res.data);

			this.setState({
				userInvitationCountEffective: res.data.userInvitationCountEffective,
				promes: res.data.promes,
				users: res.data.users,
			})
		})

	};

	updateUserInfo = () => {
		console.log('updateUserInfo');
		getUserInvitation().then(res => {
			// console.log(res.data);

			this.setState({
				userInvitationCountEffective: res.data.userInvitationCountEffective
			}, () => {
				this.setState({
					openChangeDialog: false
				})
			})
		})
	};

	userChange = () => {
		// alert('userChange')
		this.setState({
			openChangeDialog: true
		})
	}


	render() {
		const {classes} = this.props;

		return (

			<div style={{marginTop: '-10px'}}>
				<div className={classes.title}>
					<h2>{intl.get('my_profile')}: </h2>
				</div>
				<GridContainer>
					<UserChangeDialog open={this.state.openChangeDialog}
									  userInvitationCountEffective={this.state.userInvitationCountEffective}
									  enqueueSnackbar={this.props.enqueueSnackbar}
									  updateUserInfo={this.updateUserInfo.bind(this)}/>
					{/*<GridItem xs={12} sm={10} md={10} lg={4}>*/}
					<InvitationRotatingCard data={this.props.data}
											enqueueSnackbar={this.props.enqueueSnackbar}/>
					{/*<UserChangeRotatingCard*/}
					{/*	// data={this.state.changeData}*/}
					{/*	userInvitationCountEffective={this.state.userInvitationCountEffective}*/}
					{/*	enqueueSnackbar={this.props.enqueueSnackbar}*/}
					{/*	userChange={this.userChange.bind(this)}*/}
					{/*/>*/}

					<GridItem xs={12} sm={12} md={12} lg={12}>
						<AccountProme promes={this.state.promes}
									  users={this.state.users}/>
					</GridItem>
				</GridContainer>
			</div>

		);
	}
}

export default withStyles(styles)((withSnackbar)(AccountUserInfo))